export const developerCreditStyles: Record<string, React.CSSProperties> = {
  dialog: {
    border: "none",
    borderRadius: 8,
    padding: 0,
    maxWidth: 520,
    width: "100%",
    boxShadow: "0 4px 24px rgba(0, 0, 0, 0.12)",
  },
  content: { padding: 24 },
  title: { fontSize: 18, fontWeight: 600, marginBottom: 8 },
  description: {
    fontSize: 14,
    color: "var(--color-text-secondary)",
    lineHeight: 1.6,
    marginBottom: 16,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 120px",
    gap: 12,
  },
  field: { display: "grid", gap: 6 },
  fieldFull: { display: "grid", gap: 6, gridColumn: "1 / -1" },
  label: {
    fontSize: 13,
    fontWeight: 500,
    color: "var(--color-text-secondary)",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    fontSize: 14,
  },
  textarea: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    resize: "vertical" as const,
    fontSize: 14,
    lineHeight: 1.5,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 16,
  },
  cancelBtn: {
    padding: "8px 16px",
    fontSize: 14,
    borderRadius: 6,
    border: "1px solid var(--color-border)",
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  confirmBtn: {
    padding: "8px 16px",
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-primary)",
    color: "#fff",
  },
  confirmBtnDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
};
